export const STORAGE_KEY = 'onboarding_global_answers';
export const USER_ID_KEY = 'onboarding_user_id';
export const SELECTED_PLAN_KEY = 'onboarding_selected_plan';
export const URL_PARAMS_KEY = 'onboarding_url_params';
